module.exports = __webpack_public_path__ + "img/主营业务_能源系统集成04.c4b25b4e.png";